<script setup lang="ts">

import type { ICarbucksProfile } from '@domain/Carbucks';
const model = defineModel<ICarbucksProfile>( { required: true } );

</script>

<template>

    <div class="w-full tracking-wider bg-gray-850/50">
        <h1 class="p-4 pb-3 text-base lg:text-lg 3xl:text-2xl">
            Add your bank details
        </h1>
        <div class="p-4
                    bg-gradient-to-b from-gray-850 to-gray-900">
            <p class="text-sm lg:text-base 3xl:text-lg pb-2 opacity-60">
                Link your bank account to withdraw your cashback into your account.
            </p>
            <div class="mt-2 flex">
                <a :href="model.getLinkCardUrl()">
                    <Button variant="tonal"
                            class="flex items-center"
                            size="large"
                            to="/carbucks/manage-bank-account">
                        Link Bank Account
                        <Icon name="arrow-right" class="text-2xl ml-2" />
                    </Button>
                </a>
            </div>
        </div>
    </div> 

</template>
